module.exports = __webpack_public_path__ + "static/BT-mobile-6-1ed1f193250a51ccf653a404e15a5e83.jpg";